import React, { FC } from 'react'
import GenericModal from 'src/components/GenericModal'

const GenericModalContainer: FC<{
  title?: string
  children: string | React.ReactNode
  isOpen: boolean
  onClose(): any
}> = ({ title, children, isOpen, onClose }) => (
  <GenericModal title={title} isOpen={isOpen} onClose={onClose}>
    {children}
  </GenericModal>
)

export default GenericModalContainer
